var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"label":"カード名義人","hide-details":"auto","outlined":"","dense":"","error-messages":_vm.errorMessages},on:{"input":_vm.cardNameFormatter},model:{value:(_vm.display),callback:function ($$v) {_vm.display=$$v},expression:"display"}})
}
var staticRenderFns = []

export { render, staticRenderFns }